import React, { useState, useEffect, useRef } from 'react';
import {
    Grid,
    Typography,
    IconButton,
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
    Tooltip,
    Modal,
    CircularProgress,
    useMediaQuery,
    InputAdornment
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useSelector, useDispatch } from 'react-redux';
import Pagination from '../../components/global/Pagination';
import StatusChip from '../../components/common/StatusChip';
import baseUrl from '../../slices/baseUrl';
import CopyIcon from '../../images/icons/copyIcon.png';
import { useTheme } from '@mui/material/styles';
import SearchIcon from '../../images/icons/search.png';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';
import '../../App.css';
import {
    fetchRedeemReqList,
    fetchRedeemReqCount,
    searchRedeemRequestList,
    redeemRequestsDownload
} from '../../slices/requestSlice';

import { transferPayment } from '../../ContractAction/PaymentContractAction';

function RedeemRequests() {
    useEffect(() => {
        // transferPayment('0xe1dbaf0a18ae3d8609b842fc043ceddd42aacc5a', 100);
    }, []);

    const userId = sessionStorage?.getItem('userId');
    const [addRejectNoteOpen, setAddRejectNoteOpen] = useState(false);
    const [blockUnblockOpen, setBlockUnblockOpen] = useState(false);
    const [status, setStatus] = useState('');
    const [idToChangeStatus, setIdToChangeStatus] = useState('');
    const [walletAddressToPay, setWalletAddressToPay] = useState('');
    const [amountToPay, setAmountToPay] = useState('');
    const [viewerIdToPay, setViewerIdToPay] = useState('');
    const [requestIdToPay, setRequestIdToPay] = useState('');
    const [tokens, setTokens] = useState('');
    const [note, setNote] = useState('');
    const [activeButton, setActiveButton] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('');
    const dispatch = useDispatch();
    const [transactionReceipt, setTransactionReceipt] = useState([]);
    const [error, setError] = useState([]);
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));
    const [data, setData] = useState([]);
    // const [sortOrder, setSortOrder] = useState('desc');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // search
    const [showIcon, setShowIcon] = useState(true);
    const [searchText, setSearchText] = useState('');
    const textInputRef = useRef(null);
    const [searchInitiated, setSearchInitiated] = useState(false);

    let searchResult = useSelector(state => state?.request?.search);

    const loadingStatus = useSelector(state => state?.request?.status);

    const redeemReqRecords = useSelector(
        state => state?.request?.redeemReqRecords
    );
    const totalRedeemReqCount = useSelector(
        state => state?.request?.totalRedeemReqCount
    );

    //total records and count
    useEffect(() => {
        searchResult = [1];
        dispatch(fetchRedeemReqCount());
    }, []);

    useEffect(() => {
        if (totalRedeemReqCount > 1) {
            setTotalPages(
                prevPages => (prevPages = Math.ceil(totalRedeemReqCount / 20))
            );
        }
    }, [totalRedeemReqCount]);

    // sorted records
    useEffect(() => {
        dispatch(fetchRedeemReqList(currentPage));
    }, [currentPage]);

    useEffect(() => {
        if (redeemReqRecords && redeemReqRecords?.length > 0) {
            setData(redeemReqRecords);
        }
    }, [redeemReqRecords]);

    useEffect(() => {
        // transactionReceipt &&
        //     console.log('transactionReceipt', transactionReceipt);
        // if (Object.keys(transactionReceipt).length > 0) {
        //     console.log(
        //         'idToChangeStatus, status in useeffect',
        //         idToChangeStatus,
        //         status
        //     );
        //     // sendPaymentDetailsToDatabase();
        //     paymentForAdvertiser();
        // }
    }, [transactionReceipt]);

    // search
    useEffect(() => {
        if (searchInitiated) {
            if (searchResult?.length < 1) {
                setData(searchResult);
                setSnackbarMessage('No result found');
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
                return;
            } else {
                setData(searchResult);
            }
        }
    }, [searchResult]);

    // approve redeem request
    const handleInitiatePayment = async () => {
        // let txReceipt = transferPayment(walletAddressToPay, amountToPay);
        try {
            alert('handleInitiatePayment');
            const txReceipt = await transferPayment(
                walletAddressToPay,
                amountToPay
            );
            // console.log('txReceipt', txReceipt);
            setTransactionReceipt(txReceipt);
        } catch (error) {
            setError(error?.message);
        }
    };

    const paymentForAdvertiser = async event => {
        if (
            transactionReceipt?.status?.toString() === '1' ||
            transactionReceipt?.status?.toString() === '1n'
        ) {
            sendPaymentDetailsToDatabase();
        } else {
        }
    };

    const sendPaymentDetailsToDatabase = async () => {
        alert('transactionReceipt');
        // console.log('transactionReceipt', transactionReceipt);
        let viewerId = viewerIdToPay;
        let requestId = requestIdToPay;
        let redeemId = requestIdToPay;
        let paymentDetails = {
            transactionId: transactionReceipt?.transactionHash?.toString(),
            receiver:
                transactionReceipt?.events?.Transfer?.returnValues[1].toString(),
            sender: transactionReceipt?.events?.Transfer?.returnValues[0].toString(),
            status: 'completed',
            totalToken: tokens,
            value: amountToPay
        };
        try {
            const response = await fetch(
                `${baseUrl}/pay/savePaymentToViewer/${viewerId}/${redeemId}`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(paymentDetails)
                }
            );

            if (!response?.ok) {
                throw new Error(`Error: ${response?.statusText}`);
            }
            setRequestIdToPay('');
            setViewerIdToPay('');
            const data = await response?.json();
            // console.log('Post created successfully:', data);
            handleAcceptRequest(idToChangeStatus, status);
        } catch (error) {
        } finally {
            // setIsLoading(false);
        }
    };

    const handleAcceptRequest = async (idToChangeStatus, status) => {
        try {
            const response = await fetch(
                `${baseUrl}/request/update/${userId}/${idToChangeStatus}/${status}`,
                {
                    method: 'PUT'
                }
            );

            if (response?.ok) {
                const message = 'Request accepted successfully!';
                setSnackbarMessage(message);
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
                setBlockUnblockOpen(false);
                setTimeout(() => {
                    setSnackbarMessage('');
                    handleSnackbarClose();
                }, 2000);
                dispatch(fetchRedeemReqList(currentPage));
            } else {
                const error = await response?.json();
                setSnackbarMessage(error?.developermsg);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage('An error occurred.');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    // reject redeem request
    const handleRejectRequest = async (id, status, note) => {
        try {
            const response = await fetch(
                `${baseUrl}/request/update/${userId}/${id}/${status}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        note: note
                    })
                }
            );

            if (response?.ok) {
                setAddRejectNoteOpen(false);
                addRejectNoteClose();
                setActiveButton('');
                const message = 'Request rejected successfully!';
                setSnackbarMessage(message);
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
                setBlockUnblockOpen(false);
                setTimeout(() => {
                    setSnackbarMessage('');
                    handleSnackbarClose();
                }, 2000);
                dispatch(fetchRedeemReqList(currentPage));
            } else {
                const error = await response?.json();
                setSnackbarMessage(error?.developermsg);
                setSnackbarSeverity('error');
                setSnackbarOpen(true);
            }
        } catch (error) {
            setSnackbarMessage(
                'An error occurred while processing your request.'
            );
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        }
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const handleOpenRejectConfirmBox = (id, statusvalue) => {
        if (statusvalue === 'reject' && note === '') {
            setSnackbarMessage('Please enter reason for rejection');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
        } else {
            setIdToChangeStatus(id);
            setStatus(statusvalue);
            setBlockUnblockOpen(true);
        }
    };

    const handleOpenAcceptBox = (
        id,
        walletAddressValue,
        rewardsValue,
        tokensValue,
        requestIdValue,
        viewerIdValue,
        statusvalue
    ) => {
        setIdToChangeStatus(id);
        setStatus(statusvalue);
        setBlockUnblockOpen(true);
        setAmountToPay(rewardsValue);
        setTokens(tokensValue);
        setWalletAddressToPay(walletAddressValue);
        setRequestIdToPay(requestIdValue);
        setViewerIdToPay(viewerIdValue);
    };

    const handleClose1 = () => {
        setBlockUnblockOpen(false);
    };

    const handlePageChange = pageNumber => {
        setCurrentPage(pageNumber);
    };

    // show ... in wallet address
    function truncateAddress(address) {
        if (!address) return '';
        if (address?.length <= 20) return address; // No need to truncate if the address length is less than or equal to 12
        const truncatedLength = 8; // Number of characters to display before ellipsis
        const truncatedAddress = `${address?.substring(
            0,
            truncatedLength
        )}....${address?.substring(address?.length - 4)}`;
        return truncatedAddress;
    }

    // copy wallet address
    const handleTextClick = (text, msg) => {
        navigator.clipboard
            .writeText(text)
            .then(() => {
                setSnackbarMessage(msg);
                setSnackbarSeverity('success');
                setSnackbarOpen(true);
            })
            .catch(err => {
                // Error copying to clipboard
            });
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const convertDate = timedate => {
        const date = new Date(timedate);

        const day = String(date?.getDate()).padStart(2, '0');
        const month = String(date?.getMonth() + 1).padStart(2, '0');
        const year = String(date?.getFullYear());

        const formattedDate = `${day}/${month}/${year}`;
        return formattedDate;
    };

    // Reject note dialog open
    const handleOpenNoteDialog = (id, statusvalue) => {
        setIdToChangeStatus(id);
        setStatus(statusvalue);
        setAddRejectNoteOpen(true);
        // setBlockUnblockOpen(true);
    };

    const handle18plus = () => {
        setActiveButton('18plus');
        setNote('18+');
    };

    const handleInappropriate = () => {
        setActiveButton('inappropriate');
        setNote('Inappropriate');
    };

    const handleControversial = () => {
        setActiveButton('controversial');
        setNote('Controversial');
    };

    const handleTextFieldChange = event => {
        setNote(event.target.value);
    };
    const clearActive = event => {
        setActiveButton('');
    };
    const addRejectNoteClose = () => {
        setIdToChangeStatus('');
        setStatus('');
        setNote('');
        setAddRejectNoteOpen(false);
    };

    // search
    const handleBlur = e => {
        if (searchText?.length <= 0) {
            setShowIcon(true);
            setData(data);
        }
        setSearchText(e.target.value);
    };

    const handleChangeSearchText = e => {
        if (e.target.value === '') {
            setData(redeemReqRecords);
            setShowIcon(true);
        } else {
            setShowIcon(true);
        }
        setSearchText(e.target.value);
    };

    const handleSearch = () => {
        if (searchText === '') {
            setSnackbarMessage('Enter something to search');
            setSnackbarSeverity('error');
            setSnackbarOpen(true);
            return;
        }
        setShowIcon(false);
        textInputRef.current.blur();
        setSearchInitiated(true);
        dispatch(searchRedeemRequestList({ userId, searchText }));
    };

    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleClearSearch = () => {
        dispatch(fetchRedeemReqList(currentPage));
        setSearchText('');
        setShowIcon(true);
        setSearchInitiated(false);
        setSnackbarOpen(false);
    };

    const handleClickDownload = async () => {
        dispatch(redeemRequestsDownload());
    };

    return (
        <div style={{ position: 'relative' }}>
            {/* search */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    gap: 2,
                    mb: 3
                }}
            >
                <Typography variant="h5" sx={{ fontFamily: 'Outfit', fontWeight: 600 }}>
                    Redeem Requests
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <IconButton onClick={handleClickDownload} sx={{ backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' }}>
                        <DownloadIcon sx={{ color: theme.palette.primary.main }} />
                    </IconButton>
                    <TextField
                        sx={{
                            borderRadius: '30px',
                            width: '250px',
                            border: 'none',
                            color: 'text.primary',
                            '& .MuiInputBase-input': {
                                color: 'text.primary',
                                fontSize: '14px',
                                padding: '10px 14px'
                            },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '30px',
                                fontSize: '14px',
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                                transition: 'all 0.3s ease',
                                '& fieldset': { border: '1px solid transparent' },
                                '&:hover fieldset': { border: '1px solid rgba(6, 182, 212, 0.3)' },
                                '&.Mui-focused fieldset': { border: '1px solid rgba(6, 182, 212, 0.6)' }
                            }
                        }}
                        size="small"
                        value={searchText}
                        placeholder="Search..."
                        inputRef={textInputRef}
                        onChange={handleChangeSearchText}
                        autoComplete="off"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" onClick={showIcon ? handleSearch : handleClearSearch} sx={{ cursor: 'pointer', pl: 1 }}>
                                    {showIcon && <img src={SearchIcon} alt="search" style={{ height: '18px', opacity: 0.7 }} />}
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end" onClick={showIcon ? handleSearch : handleClearSearch} sx={{ cursor: 'pointer', pr: 1 }}>
                                    {!showIcon && <CloseIcon sx={{ color: 'text.primary' }} />}
                                </InputAdornment>
                            )
                        }}
                        onKeyDown={handleKeyPress}
                    />
                </Box>
            </Box>
            {loadingStatus === 'loading' ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 10 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box
                    className="glass-panel"
                    sx={{
                        borderRadius: '16px',
                        overflow: 'hidden',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        background: theme.palette.mode === 'dark' ? 'rgba(17, 25, 40, 0.75)' : 'rgba(255, 255, 255, 0.7)',
                        backdropFilter: 'blur(12px)',
                        mb: 4
                    }}
                >
                    <Box sx={{ overflowX: 'auto' }}>
                        <Box sx={{ minWidth: '1000px' }}>
                            <Grid
                                container
                                sx={{
                                    padding: '14px 24px',
                                    background: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)',
                                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                                    '& .MuiGrid-item': {
                                        color: theme.palette.primary.main,
                                        fontWeight: 700,
                                        fontSize: '11px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '1.2px'
                                    }
                                }}
                            >
                                <Grid item xs={0.75} textAlign="center">
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>Sr.No.</Typography>
                                </Grid>
                                <Grid item xs={2.1}>
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit', pl: 1 }}>Wallet Address</Typography>
                                </Grid>
                                <Grid item xs={1.5}>
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit', pl: 1 }}>Rewards (TT)</Typography>
                                </Grid>
                                <Grid item xs={2} textAlign="center">
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>USDT Value</Typography>
                                </Grid>
                                <Grid item xs={1.2} textAlign="center">
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>Date</Typography>
                                </Grid>
                                <Grid item xs={2.1}>
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit', pl: 1 }}>Transaction Hash</Typography>
                                </Grid>
                                <Grid item xs={2.35} textAlign="center">
                                    <Typography sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>Action</Typography>
                                </Grid>
                            </Grid>

                            <Box sx={{ width: '100%' }}>
                                {data?.length > 0 ? (
                                    data.map((item, index) => (
                                        <Grid
                                            container
                                            key={item?.id}
                                            className="grid-table-container"
                                            sx={{
                                                padding: '10px 24px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: index % 2 === 0 ? 'transparent' : (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.01)' : 'rgba(0, 0, 0, 0.01)'),
                                                transition: 'all 0.2s ease',
                                                borderBottom: '1px solid rgba(255, 255, 255, 0.03)',
                                                '&:hover': {
                                                    background: theme.palette.mode === 'dark' ? 'rgba(6, 182, 212, 0.06)' : 'rgba(6, 182, 212, 0.04)'
                                                }
                                            }}
                                        >
                                            <Grid item xs={0.75} textAlign="center">
                                                <Typography sx={{ fontSize: '13px', opacity: 0.8 }}>
                                                    {(currentPage - 1) * 20 + index + 1}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Tooltip title={<Typography sx={{ fontSize: '12px' }}>{item?.walletAddress}</Typography>} placement="bottom">
                                                    <Typography
                                                        sx={{
                                                            overflow: 'hidden',
                                                            fontSize: '13px',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            pl: 1
                                                        }}
                                                    >
                                                        {truncateAddress(item?.walletAddress)}
                                                        {item?.walletAddress && (
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => handleTextClick(item?.walletAddress, 'Wallet address copied successfully!')}
                                                                sx={{ ml: 0.5, p: 0.5, opacity: 0.7, '&:hover': { opacity: 1 } }}
                                                            >
                                                                <img src={CopyIcon} alt="copy" style={{ width: '14px', height: '14px' }} />
                                                            </IconButton>
                                                        )}
                                                    </Typography>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={1.5}>
                                                <Typography sx={{ fontSize: '13px', pl: 1, opacity: 0.9 }}>
                                                    {item?.tokens} TT
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} textAlign="center">
                                                <Typography sx={{ fontSize: '13px', fontWeight: 600, color: theme.palette.primary.main }}>
                                                    {item?.rewards} USDT
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={1.2} textAlign="center">
                                                <Typography sx={{ fontSize: '13px', opacity: 0.8 }}>
                                                    {convertDate(item?.date)}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2.1}>
                                                <Tooltip title={<Typography sx={{ fontSize: '12px' }}>{item?.transactionHash}</Typography>} placement="top">
                                                    <Typography
                                                        sx={{
                                                            overflow: 'hidden',
                                                            fontSize: '13px',
                                                            whiteSpace: 'nowrap',
                                                            textOverflow: 'ellipsis',
                                                            pl: 1,
                                                            opacity: 0.8
                                                        }}
                                                    >
                                                        {truncateAddress(item?.transactionHash)}
                                                    </Typography>
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={2.35} textAlign="center">
                                                {item?.status === 'complete' ? (
                                                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                        <StatusChip status="active" label="Completed" />
                                                    </Box>
                                                ) : item?.status === 'reject' ? (
                                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 1 }}>
                                                        <StatusChip status="rejected" label="Rejected" />
                                                        {item?.note && (
                                                            <Tooltip title={<Typography sx={{ fontSize: '11px' }}>Reason: {item?.note}</Typography>} placement="top">
                                                                <IconButton size="small">
                                                                    <InfoIcon sx={{ fontSize: '18px', color: theme.palette.primary.main }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        )}
                                                    </Box>
                                                ) : (
                                                    <Box sx={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            sx={{
                                                                textTransform: 'none',
                                                                minWidth: '70px',
                                                                borderRadius: '6px',
                                                                fontSize: '11px',
                                                                padding: '2px 8px',
                                                                borderColor: theme.palette.error.main,
                                                                color: theme.palette.error.main,
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(239, 68, 68, 0.05)',
                                                                    borderColor: theme.palette.error.dark
                                                                }
                                                            }}
                                                            onClick={() => handleOpenNoteDialog(item?.id, 'reject')}
                                                        >
                                                            Reject
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            size="small"
                                                            sx={{
                                                                textTransform: 'none',
                                                                minWidth: '70px',
                                                                borderRadius: '6px',
                                                                fontSize: '11px',
                                                                padding: '2px 8px',
                                                                backgroundColor: theme.palette.primary.main,
                                                                color: theme.palette.primary.contrastText,
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.primary.dark
                                                                }
                                                            }}
                                                            onClick={() =>
                                                                handleOpenAcceptBox(
                                                                    item?.id,
                                                                    item?.walletAddress,
                                                                    item?.rewards,
                                                                    item?.tokens,
                                                                    item?.id,
                                                                    item?.viewerId,
                                                                    'solve'
                                                                )
                                                            }
                                                        >
                                                            Accept
                                                        </Button>
                                                    </Box>
                                                )}
                                            </Grid>
                                        </Grid>
                                    ))
                                ) : (
                                    <Box sx={{ p: 4, textAlign: 'center' }}>
                                        <Typography sx={{ opacity: 0.6 }}>No redeem requests found.</Typography>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            )}
            <Modal
                open={blockUnblockOpen}
                onClose={handleClose1}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    className="reject-grid-container"
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isLargeScreen ? '30vw' : '85vw',
                        backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
                        color: 'text.primary',
                        borderRadius: '20px',
                        boxShadow: 24,
                        padding: '30px',
                        textAlign: 'center',
                        outline: 'none'
                    }}
                >
                    <WarningIcon fontSize="large" color="warning" />
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mt: 2, fontWeight: 600 }}
                    >
                        Are you sure?
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        sx={{ mt: 1, color: 'text.secondary', fontSize: '14px' }}
                    >
                        {status === 'accept'
                            ? 'You are about to accept this redeem request and initiate payment.'
                            : 'You are about to reject this redeem request.'}
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            mt: 4,
                            gap: 2
                        }}
                    >
                        <Button
                            onClick={() =>
                                status === 'accept'
                                    ? handleInitiatePayment()
                                    : handleRejectRequest(
                                        idToChangeStatus,
                                        status,
                                        note
                                    )
                            }
                            sx={{
                                width: '120px',
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                borderRadius: '8px',
                                fontWeight: 600,
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark
                                }
                            }}
                        >
                            Yes
                        </Button>
                        <Button
                            onClick={handleClose1}
                            sx={{
                                width: '120px',
                                color: 'text.primary',
                                backgroundColor: 'transparent',
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: '8px',
                                fontWeight: 600,
                                textTransform: 'none',
                                '&:hover': {
                                    backgroundColor: 'rgba(150,150,150,0.1)'
                                }
                            }}
                        >
                            No
                        </Button>
                    </Box>
                </Box>
            </Modal>
            {/* reject note */}
            <Dialog
                maxWidth="xs"
                PaperProps={{
                    style: {
                        height: '60vh',
                        width: isLargeScreen ? '50vw' : '',
                        backgroundImage: `linear-gradient(to top right, ${theme.palette.background.default}, ${theme.palette.background.paper})`,
                        color: 'text.primary',
                        borderRadius: '30px',
                        padding: '10px 30px'
                    }
                }}
                open={addRejectNoteOpen}
                onClose={addRejectNoteClose}
            >
                <>
                    <DialogTitle
                        style={{
                            textAlign: 'center',
                            color: 'text.primary'
                        }}
                    >
                        Select Reason for Rejection
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            sx={{
                                fontSize: '12px',
                                textAlign: 'left',
                                color: 'text.primary',
                                marginBottom: '10px',
                                marginTop: '20px'
                            }}
                        >
                            Enter the reason for Rejecting redeem request:
                        </DialogContentText>
                        <Box
                            component="form"
                            noValidate
                            sx={{
                                mt: 0.5,
                                backgroundColor: 'rgba(150,150,150,0.1)',
                                borderRadius: '8px'
                            }}
                        >
                            <TextField
                                placeholder="Explain your reason"
                                name="description"
                                value={note}
                                onChange={handleTextFieldChange}
                                onFocus={clearActive}
                                fullWidth
                                multiline
                                sx={{
                                    borderRadius: '8px',
                                    border: 'none',
                                    color: 'text.primary',
                                    '& .MuiInputBase-input': {
                                        color: 'text.primary',
                                        fontSize: '12px',
                                        minHeight: '50px'
                                    },
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '8px',
                                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(150,150,150,0.1)' : 'rgba(0,0,0,0.05)',
                                        '& fieldset': {
                                            border: 'none'
                                        },
                                        '&:hover fieldset': {
                                            border: 'none'
                                        },
                                        '&.Mui-focused fieldset': {
                                            border: 'none'
                                        }
                                    },
                                    '& .MuiFilledInput-root': {
                                        height: '30px'
                                    }
                                }}
                                autoComplete="off"
                                size="small"
                                variant="outlined"
                            />
                            {/* <Box
                                sx={{
                                    paddingLeft: '12px',
                                    paddingBottom: '12px'
                                }}
                            >
                                <Button
                                    sx={{
                                        textTransform: 'none',
                                        fontSize: '12px',
                                        color:
                                            activeButton === '18plus'
                                                ? '#0A0B2A'
                                                : 'rgba(10, 231, 254, 1)',
                                        bgcolor:
                                            activeButton === '18plus'
                                                ? '#0AE7FE'
                                                : 'rgba(106, 117, 138, 0.11)',
                                        borderRadius: '99px',
                                        padding: '6px 10px',
                                        pointerEvents:
                                            activeButton === '18+'
                                                ? 'none'
                                                : 'auto'
                                    }}
                                    onClick={handle18plus}
                                >
                                    18+
                                </Button>
                                <Button
                                    sx={{
                                        ml: 1,
                                        textTransform: 'none',
                                        color:
                                            activeButton === 'inappropriate'
                                                ? '#0A0B2A'
                                                : 'rgba(10, 231, 254, 1)',
                                        bgcolor:
                                            activeButton === 'inappropriate'
                                                ? '#0AE7FE'
                                                : 'rgba(106, 117, 138, 0.11)',
                                        borderRadius: '99px',
                                        padding: '5px 10px',
                                        pointerEvents:
                                            activeButton === 'Inappropriate'
                                                ? 'none'
                                                : 'auto'
                                    }}
                                    onClick={handleInappropriate}
                                >
                                    Inappropriate
                                </Button>
                                <Button
                                    sx={{
                                        ml: 1,
                                        textTransform: 'none',
                                        color:
                                            activeButton === 'controversial'
                                                ? '#0A0B2A'
                                                : 'rgba(10, 231, 254, 1)',
                                        bgcolor:
                                            activeButton === 'controversial'
                                                ? '#0AE7FE'
                                                : 'rgba(106, 117, 138, 0.11)',
                                        borderRadius: '99px',
                                        padding: '5px 10px',
                                        pointerEvents:
                                            activeButton === 'Controversial'
                                                ? 'none'
                                                : 'auto'
                                    }}
                                    onClick={handleControversial}
                                >
                                    Controversial
                                </Button>
                            </Box> */}
                        </Box>

                        <Button
                            size="small"
                            fullWidth
                            sx={{
                                textTransform: 'none',
                                marginTop: '20px',
                                fontWeight: 600,
                                padding: '7px',
                                borderRadius: '8px',
                                color: theme.palette.primary.contrastText,
                                backgroundColor: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: theme.palette.primary.dark
                                }
                            }}
                            variant="contained"
                            onClick={e =>
                                handleOpenRejectConfirmBox(
                                    idToChangeStatus,
                                    status
                                )
                            }
                        >
                            Submit
                        </Button>

                        <div style={{ textAlign: 'right' }}>
                            <Button
                                size="small"
                                onClick={addRejectNoteClose}
                                sx={{
                                    textDecoration: 'none',
                                    textTransform: 'none',
                                    color: theme.palette.primary.main,
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </DialogContent>
                </>
            </Dialog>
            <Grid
                container
                style={{
                    display: 'flex',
                    overflow: 'hidden',
                    position: 'fixed',
                    bottom: 5,
                    margin: '20px 0 -20px 0px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'transparent',
                    padding: '5px 0 20px 10px',
                    zIndex: 11
                }}
            >
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                />
            </Grid>
            {snackbarOpen && (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right'
                    }}
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                >
                    <Alert
                        elevation={6}
                        onClose={handleCloseSnackbar}
                        severity={snackbarSeverity}
                    >
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            )}
        </div>
    );
}

export default RedeemRequests;
